import {IconDefinition} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {boundMethod} from "autobind-decorator";
import React from "react";
import {injectIntl, IntlShape} from "react-intl";

import {
    MODAL_VALUE,
    NO_SOP_VALUE,
} from "@/components/warnings/hard-drice-space/models";

import ModalWarning from "@/components/warnings/hard-drice-space/ModalWarning";
import {intl2Str} from "@translate/T";

interface IExecuteButtonProps {
    intl: IntlShape;
    id?: string;
    icon: IconDefinition | string;
    iconOnly?: boolean;
    url?: string;
    launchRecorder?: boolean;
    children?: React.ReactNode;

    onClick: () => void;
}

class ExecuteButton extends React.PureComponent<IExecuteButtonProps> {
    private readonly ref = React.createRef<ModalWarning>();

    @boundMethod
    public onClick() {
        const current = this.ref.current;
        if (!current) {
            return;
        }

        if (current.state.value <= NO_SOP_VALUE) {
            current.open();
            return;
        }

        this.props.onClick();

        if (current.state.value <= MODAL_VALUE) {
            current.open();
        }
    }

    public render() {
        const {iconOnly} = this.props;

        return (
            <React.Fragment>
                <ModalWarning ref={this.ref} />
                {iconOnly ? this.renderIconOnly() : this.renderButton()}
            </React.Fragment>
        );
    }

    private renderButton() {
        const {id, url} = this.props;
        const linkClassName = "mr-1";
        const buttonClassName = "btn btn-success";

        if (url === undefined) {
            return (
                <button
                    type="button"
                    id={id}
                    className={buttonClassName + " " + linkClassName}
                    onClick={this.onClick}
                >
                    {this.renderIcon()}
                </button>
            );
        }

        return (
            <a className={linkClassName} href={url} onClick={this.onClick}>
                <button type="button" className={buttonClassName}>
                    {this.renderIcon()}
                </button>
            </a>
        );
    }

    private getTitle() {
        const {intl, launchRecorder} = this.props;
        if (launchRecorder) {
            return intl2Str(intl, "Execute");
        } else {
            return intl2Str(intl, "Queue");
        }
    }

    private renderIconOnly() {
        const {icon, url} = this.props;

        if (typeof icon === "string") {
            return (
                <a href={url} onClick={this.onClick} title={this.getTitle()}>
                    <img className="icon-text icon-flash" src={icon} />
                </a>
            );
        }

        return (
            <a href={url} onClick={this.onClick} title={this.getTitle()}>
                <FontAwesomeIcon
                    icon={icon}
                    fixedWidth={true}
                    className="mr-1"
                />
            </a>
        );
    }

    private renderIcon() {
        const {icon, children} = this.props;

        if (typeof icon === "string") {
            return (
                <React.Fragment>
                    <img className="icon-text icon-flash" src={icon} />
                    {children}
                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                <FontAwesomeIcon
                    icon={icon}
                    fixedWidth={true}
                    className="mr-1"
                />
                {children}
            </React.Fragment>
        );
    }
}

export default injectIntl(ExecuteButton);
